export default {
  namespaced: true,
  state: {
    valid: true,
    sheetIds: {},
    lists: {
      type: [],
      spendCategory: [],
      transactionType: [],
      payMethod: [],
      vendor: [],
      receipt: [],
      trip: [],
      taxCategory: [],
      exercise: [],
      muscleGroup: [],
      meals: [],
      account: [],
      tag: [],
      food: []
    },
    type: {
      // Make sure there is a selected value for type
      rules: [v => !!v || "Type is required"],
      selected: "",
      items: []
    },
    name: {
      // Make sure there is a selected value for name
      rules: [v => !!v || "Name is required"],
      selected: "",
      items: [],
      newName: "",
      id: "",
      uuid: ""
    },
    tag: {
      selected: "",
      items: []
    },
    description: "",
    location: {
      show: false,
      value: ""
    },
    url: {
      show: false,
      value: ""
    },
    business: {
      show: false,
      value: false
    },
    dates: {
      startDate: {
        date: new Date(new Date().setHours(12, 59, 0, 0))
          .toISOString()
          .substr(0, 10),
        menu: false,
        show: false
      },
      endDate: {
        date: new Date(new Date().setHours(12, 59, 0, 0))
          .toISOString()
          .substr(0, 10),
        menu: false,
        show: false
      }
    },
    snackbar: {
      model: false,
      text: "Test",
      color: "secondary",
      timeout: 4000
    }
  },
  getters: {},
  mutations: {
    UPDATE_STATE: (state, payload) => {
      if (payload.field && payload.subfield) {
        state[payload.state][payload.field][payload.subfield] = payload.value;
      } else if (payload.field) {
        state[payload.state][payload.field] = payload.value;
      } else {
        state[payload.state] = payload.value;
      }
    }
  },
  actions: {
    updateState: ({ commit }, payload) => {
      commit("UPDATE_STATE", payload);
    }
  }
};
